import { FC } from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { Paths } from '../../constants/paths.ts';
import { useNavigate } from 'react-router-dom';
import { Dialogs } from '../../constants/dialogs.ts';
import { useDialog } from '../../contexts/dialog.context.tsx';
import { trackEvent } from '../../utils/analytics.ts';

export const LetGetStartedPage: FC = () => {
  const navigate = useNavigate();
  const { openDialog } = useDialog();
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        pt: 5
      }}
    >
      <Container
        maxWidth="md"
        sx={{
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box component="img" src="/logo.svg" alt="logo" sx={{ height: '8rem', mb: 3 }} />
        <Typography variant="h4" paragraph>
          Let's Get Started!
        </Typography>
        <Typography>Congratulations on taking the first step to improving your well-being! The next step is to set up your first activity.</Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 3 }}
          onClick={() => {
            navigate(Paths.HOME);
            openDialog(Dialogs.REGISTRATION_SUCCESS);
            trackEvent('onboarding_complete');
          }}
        >
          Get Started
        </Button>
      </Container>
    </Box>
  );
};
